const UserPreferenceApiUrls = {
  TZ_GET: `${process.env.REACT_APP_CLOG_SHARED_SERVICE_ORIGIN_URL}/tz-user-pref/current-user/get`,
  TZ_PUT: `${process.env.REACT_APP_CLOG_SHARED_SERVICE_ORIGIN_URL}/tz-user-pref/update`,
  TZ_OPTIONS_GET: `${process.env.REACT_APP_CLOG_SHARED_SERVICE_ORIGIN_URL}/tz-user-pref/timezone-option/get`,
};

export default UserPreferenceApiUrls

